export var FeatureFlagActionType;
(function (FeatureFlagActionType) {
    FeatureFlagActionType["payLater"] = "payLater";
    FeatureFlagActionType["showMarketingSettings"] = "showMarketingSettings";
    FeatureFlagActionType["showPrivacySettings"] = "showPrivacySettings";
})(FeatureFlagActionType || (FeatureFlagActionType = {}));
